import { render, staticRenderFns } from "./settingRow.vue?vue&type=template&id=5c2cc0bd&scoped=true&"
import script from "./settingRow.vue?vue&type=script&lang=js&"
export * from "./settingRow.vue?vue&type=script&lang=js&"
import style0 from "../less/settingRow.less?vue&type=style&index=0&id=5c2cc0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2cc0bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2cc0bd')) {
      api.createRecord('5c2cc0bd', component.options)
    } else {
      api.reload('5c2cc0bd', component.options)
    }
    module.hot.accept("./settingRow.vue?vue&type=template&id=5c2cc0bd&scoped=true&", function () {
      api.rerender('5c2cc0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/include/settingRow.vue"
export default component.exports